import React, { ImgHTMLAttributes } from 'react';

type Props = ImgHTMLAttributes<SVGElement>;

const Gauge: React.FC<Props> = ({ className }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <path
      d='M8.55441 8.11433C9.60668 7.64701 10.772 7.38696 12 7.38696C16.6947 7.38696 20.5 11.1931 20.5 15.887C20.5 17.115 20.24 18.2803 19.7728 19.3326C19.6047 19.7112 19.7753 20.1543 20.1539 20.3224C20.5324 20.4905 20.9756 20.3199 21.1437 19.9413C21.6944 18.7011 22 17.3287 22 15.887C22 10.3648 17.5233 5.88696 12 5.88696C10.5582 5.88696 9.1858 6.19265 7.94559 6.74344C7.56703 6.91156 7.39643 7.35473 7.56456 7.73329C7.73268 8.11185 8.17585 8.28245 8.55441 8.11433Z'
      fill='currentColor'
    />
    <path
      d='M4.22737 12.4414C4.39549 12.0628 4.22489 11.6196 3.84633 11.4515C3.46777 11.2834 3.0246 11.454 2.85648 11.8326C2.30569 13.0728 2 14.4452 2 15.887C2 17.3287 2.30569 18.7012 2.85648 19.9414C3.0246 20.3199 3.46777 20.4905 3.84633 20.3224C4.22489 20.1543 4.39549 19.7111 4.22737 19.3326C3.76005 18.2803 3.5 17.1149 3.5 15.887C3.5 14.659 3.76005 13.4936 4.22737 12.4414Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.28816 12.064L8.28812 11.064C8.2376 11.0135 8.18167 10.9717 8.12218 10.9386L4.78044 7.59687C4.48755 7.30397 4.01268 7.30397 3.71978 7.59687C3.42689 7.88976 3.42689 8.36463 3.71978 8.65753L9.71978 14.6575C9.74453 14.6823 9.77058 14.7049 9.79771 14.7255C9.77836 14.7622 9.75981 14.7995 9.74209 14.8375C9.15863 16.0887 9.70008 17.5764 10.9513 18.1598C12.2026 18.7433 13.6902 18.2018 14.2736 16.9506C14.8572 15.6991 14.3156 14.2117 13.0644 13.6283C12.3312 13.2864 11.5168 13.3307 10.8507 13.6778C10.8295 13.6496 10.8061 13.6225 10.7804 13.5969L9.4137 12.2301C9.38058 12.1706 9.33874 12.1146 9.28816 12.064ZM11.1016 15.4714C10.8682 15.9719 11.0848 16.567 11.5852 16.8004C12.0857 17.0337 12.6808 16.8171 12.9142 16.3167C13.1476 15.8161 12.931 15.2211 12.4305 14.9877C11.93 14.7544 11.335 14.9709 11.1016 15.4714Z'
      fill='currentColor'
    />
    <path
      d='M15.75 15.8372C15.75 15.4229 16.0858 15.0872 16.5 15.0872H18C18.4142 15.0872 18.75 15.4229 18.75 15.8372C18.75 16.2514 18.4142 16.5872 18 16.5872H16.5C16.0858 16.5872 15.75 16.2514 15.75 15.8372Z'
      fill='currentColor'
    />
    <path
      d='M6 15.0872C5.58579 15.0872 5.25 15.4229 5.25 15.8372C5.25 16.2514 5.58579 16.5872 6 16.5872H7.5C7.91421 16.5872 8.25 16.2514 8.25 15.8372C8.25 15.4229 7.91421 15.0872 7.5 15.0872H6Z'
      fill='currentColor'
    />
    <path
      d='M11.25 11.8372V9.83716C11.25 9.42294 11.5858 9.08716 12 9.08716C12.4142 9.08716 12.75 9.42294 12.75 9.83716V11.8372C12.75 12.2514 12.4142 12.5872 12 12.5872C11.5858 12.5872 11.25 12.2514 11.25 11.8372Z'
      fill='currentColor'
    />
    <path
      d='M16.7724 12.1243C17.0653 11.8314 17.0653 11.3566 16.7724 11.0637C16.4795 10.7708 16.0046 10.7708 15.7117 11.0637L14.7117 12.0637C14.4189 12.3566 14.4189 12.8314 14.7117 13.1243C15.0046 13.4172 15.4795 13.4172 15.7724 13.1243L16.7724 12.1243Z'
      fill='currentColor'
    />
  </svg>
);

export { Gauge };
